import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Container, Paper, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const AuthWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.palette.background.default,
  padding: theme.spacing(3),
}));

const AuthPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  maxWidth: '450px',
  width: '100%',
  boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
  borderRadius: '12px',
}));

const AuthLayout = () => {
  return (
    <AuthWrapper>
      <Container maxWidth="sm">
        <AuthPaper>
          <Typography 
            component="h1" 
            variant="h4" 
            color="primary" 
            gutterBottom
            sx={{ fontWeight: 'bold', mb: 3 }}
          >
            Clinic Management System
          </Typography>
          <Outlet />
        </AuthPaper>
      </Container>
    </AuthWrapper>
  );
};

export default AuthLayout;